import Axios from './APIService';
import { AxiosPromise } from 'axios';
import Product from '@/types/Product';

const apiBase = '/collections';

const CollectionAPI = {

    getCollection(collectionId: string): AxiosPromise<Product[]> {
        return Axios.get<Product[]>(`${apiBase}/${collectionId}`);
    }

};

export default CollectionAPI;
